import React from 'react'
import aws from '../../images/aws.png'
import { ExternalLink } from '@labrav/react-components'

import { useStyles } from './RequirementsActionV2.styles'

interface RequirementsActionProps {
  link: string
  linkText?: string
  id?: string
}

export const RequirementsActionV2: React.FC<RequirementsActionProps> = ({
  link,
  linkText,
  id,
}) => {
  const { classes } = useStyles()
  return (
    <div
      className={classes.container}
      data-testid="requirements-button"
      id={id}
    >
      <img src={aws} className={classes.image} alt="AWS Image" />
      <div className={classes.linkText}>
        <ExternalLink href={link}>{linkText}</ExternalLink>
      </div>
    </div>
  )
}
